import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../store/auth.store';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/** Avatar + account menu in the topbar — real signed-in user, with a working sign-out action. */
export function UserAvatarButton() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  if (!user) return null;

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label="account menu"
          className="ml-1 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-xs font-bold text-white"
        >
          {initials(user.name)}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className="z-50 w-[220px] rounded-xl border border-border bg-surface p-1.5 shadow-xl outline-none"
        >
          <div className="border-b border-border px-2.5 py-2">
            <p className="truncate text-sm font-semibold text-text-primary">{user.name}</p>
            <p className="truncate text-xs text-text-secondary">
              {capitalize(user.role)} · {user.email}
            </p>
          </div>
          <DropdownMenu.Item
            onSelect={() => void handleLogout()}
            className="mt-1 flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-2 text-sm font-medium text-text-primary outline-none hover:bg-surface-hover"
          >
            <LogOut size={15} />
            Sign out
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
